import React from 'react';
import { withRouter } from 'react-router-dom';
import { Col, FormGroup, Row } from 'react-bootstrap';
import { SaveCancel, Label } from 'fw/components';
import { Form, IntBox, CheckBox } from 'fw/forms';
import * as Notifications from 'fw/globals/Notifications';
import * as FormManager from 'fw/forms/form/FormManager';
import * as API from 'modules/app/API';
import * as Modals from 'fw/globals/Modals';
import * as Help from 'modules/app/Help';

class SettingsTab extends React.Component {

	constructor(props) {
		super(props);
		this.state = this.initialState();
	}

	initialState = () => {
		return {
			loading: true,
			title: "",
			form: {}
		};
	}

	load = () => {
		// Nothing to load on this tab
	}

	get = () => {
		API.App.get('/appConfig/getSettings', {},
			{
				success: (r) => {
					this.setState((prevState, props) => ({
						loading: false,
						form: r.data
					}));
				}
			});
	}

	save = (rowVersion) => {
		const form = this.state.form;
		const me = this;

		let rq = {
			configId: form.configId,
			defaultSessionTimeoutMinutes: form.defaultSessionTimeoutMinutes,
			newUserRegistrationLinkExpirationDays: form.newUserRegistrationLinkExpirationDays,
			newUserRegistrationValidationCodeExpirationMinutes: form.newUserRegistrationValidationCodeExpirationMinutes,
			resetPasswordLinkExpirationDays: form.resetPasswordLinkExpirationDays,
			blockUserAfterUnsuccessfulLoginAttempts: form.blockUserAfterUnsuccessfulLoginAttempts,
			blockUserAfterUnsuccessfulResetPasswordAttempts: form.blockUserAfterUnsuccessfulResetPasswordAttempts,
			clearUserAccessBlockMinutes: form.clearUserAccessBlockMinutes,
			passwordTracking: form.passwordTracking,
			allowPreviousPasswordReuse: form.allowPreviousPasswordReuse,
			expirePasswordAfterDays: form.expirePasswordAfterDays,
			informUserBeforeExpirationDays: form.informUserBeforeExpirationDays,
			twoFactorAuthentication: form.twoFactorAuthentication,
			requiredSecurityQuestionNumber: form.requiredSecurityQuestionNumber,
			requiredSecurityAnswersNumber: form.requiredSecurityAnswersNumber,
			rowVersion: rowVersion || form.rowVersion
		};

		API.App.post('/appConfig/saveSettings', rq,
			{
				success: (r) => {
					Notifications.success(r.message);
					me.get(r.data.entityId);
				},
				error: (r) => {
					if (r.data && r.data.rowVersion) {
						Modals.confirm(r.error.errorMessage,
							function () {
								me.save(r.data.rowVersion);
							},
							function () {
								me.get(r.data.entityId);
							}
						);
					} else {
						Notifications.error(r.error.errorMessage);
					}
				}
			});
	}

	cancel = () => {
		this.props.history.push('/');
	}

	handleSubmit = () => {
		this.save();
	}

	handleCancel = () => {
		const me = this;

		FormManager.checkUnsavedChanges(function () {
			me.cancel();
		})
	}

	handleChange = (form) => {
		this.setState({ form });
	}

	setHelp = () => {
		if (this.props.helpKey)
			Help.setHelp(this.props.helpKey)
		else
			Help.clearHelp();
	}

	componentDidMount() {
		this.get();
		this.setHelp();
	}

	render() {
		var style = {
			float: 'right',
			width: '60px'
		};

		var paddingStyle = {
			'paddingLeft': '20px'
		};

		return (
			<React.Fragment>
				<Form
					onChange={this.handleChange}
					onSubmit={this.handleSubmit}
					values={this.state.form}
					unsavedChangesWarning={true}>
					<Row>
						<Col md={12} lg={4}>
							<FormGroup>
								<Label htmlFor="defaultSessionTimeoutMinutes" required>Default Session Timeout (minutes)</Label>
								<IntBox name="defaultSessionTimeoutMinutes" maxLength="3" style={style} required positiveOnly />
							</FormGroup>
							<div className="clearfix"></div>
							<FormGroup>
								<Label htmlFor="newUserRegistrationLinkExpirationDays" required>New User Registration Link Expiration (days)</Label>
								<IntBox name="newUserRegistrationLinkExpirationDays" maxLength="2" style={style} required positiveOnly />
							</FormGroup>
							<div className="clearfix"></div>
							<FormGroup>
								<Label htmlFor="newUserRegistrationValidationCodeExpirationMinutes" required>New Registration Validation Code Expiration (minutes)</Label>
								<IntBox name="newUserRegistrationValidationCodeExpirationMinutes" maxLength="4" style={style} required positiveOnly />
							</FormGroup>
							<div className="clearfix"></div>
							<FormGroup>
								<Label htmlFor="resetPasswordLinkExpirationDays" required>Reset Password Link Expiration (days)</Label>
								<IntBox name="resetPasswordLinkExpirationDays" maxLength="3" style={style} required positiveOnly />
							</FormGroup>
							<FormGroup>
								<Label htmlFor="requiredSecurityQuestionNumber" required>Required Security Question (number)</Label>
								<IntBox name="requiredSecurityQuestionNumber" maxLength="2" style={style} required positiveOnly />
							</FormGroup>
							<div className="clearfix"></div>
						</Col>
						<Col md={12} lg={4}>
							<FormGroup>
								<Label htmlFor="blockUserAfterUnsuccessfulLoginAttempts" required>Block User after Unsuccessful Login Attempts</Label>
								<IntBox name="blockUserAfterUnsuccessfulLoginAttempts" maxLength="2" style={style} required positiveOnly />
							</FormGroup>
							<div className="clearfix"></div>
							<FormGroup>
								<Label htmlFor="blockUserAfterUnsuccessfulResetPasswordAttempts" required>Block User after Unsuccessful Reset Password Attempts</Label>
								<IntBox name="blockUserAfterUnsuccessfulResetPasswordAttempts" maxLength="2" style={style} required positiveOnly />
							</FormGroup>
							<div className="clearfix"></div>
							<FormGroup>
								<Label htmlFor="clearUserAccessBlockMinutes" required>Clear User Access Block (minutes)</Label>
								<IntBox name="clearUserAccessBlockMinutes" maxLength="2" style={style} required positiveOnly />
							</FormGroup>
							<div className="clearfix"></div>
							<FormGroup>
								<Label htmlFor="requiredSecurityAnswersNumber" required>Required Security Answers (number)</Label>
								<IntBox name="requiredSecurityAnswersNumber" maxLength="2" style={style} required positiveOnly />
							</FormGroup>
							<FormGroup className="form-inline">
								<Label htmlFor="twoFactorAuthentication" >Two Factor Authentication   </Label>
								<CheckBox name="twoFactorAuthentication" style={style} label="" inline />
							</FormGroup>
							<div className="clearfix"></div>
						</Col>
						<Col md={12} lg={4}>
							<FormGroup className="form-inline">
								<Label htmlFor="passwordTracking" >Enable Password Tracking   </Label>
								<CheckBox name="passwordTracking" style={style} label="" inline />
							</FormGroup>
							<FormGroup style={paddingStyle}>
								<Label htmlFor="allowPreviousPasswordReuse" required>Allow Previous Password Reuse (changes)</Label>
								<IntBox name="allowPreviousPasswordReuse" disabled={!this.state.form.passwordTracking} maxLength="2" style={style} required positiveOnly />
							</FormGroup>
							<div className="clearfix"></div>
							<FormGroup style={paddingStyle}>
								<Label htmlFor="expirePasswordAfterDays" required>Expire Password After (days)</Label>
								<IntBox name="expirePasswordAfterDays" disabled={!this.state.form.passwordTracking} maxLength="2" style={style} required positiveOnly />
							</FormGroup>
							<div className="clearfix"></div>
							<FormGroup style={paddingStyle}>
								<Label htmlFor="informUserBeforeExpirationDays" required>Inform User Before Expiration (days)</Label>
								<IntBox name="informUserBeforeExpirationDays" disabled={!this.state.form.passwordTracking} maxLength="2" style={style} required positiveOnly />
							</FormGroup>
							<div className="clearfix"></div>
						</Col>
					</Row>
					<hr />
					<SaveCancel onCancel={this.handleCancel} />
				</Form>
			</React.Fragment>)
	}
}

export default withRouter(SettingsTab);



// WEBPACK FOOTER //
// ./src/areas/admin/appConfig/settings/SettingsTab.js